import { italianMovies, italianMoviesForEnUs } from '../data/italianMovies/italianMovies.data';
import { MoviesTagPageContent } from '../MoviesTagPageContent';
import { TagPageProps } from '../types/tagPageProps';

export const Content = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={italianMovies} />
);

export const ContentEnUs = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={italianMoviesForEnUs} />
);
